import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { FaAtlassian } from 'react-icons/fa';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

// eslint-disable-next-line css-modules/no-unused-class
import s from './LoginForm.scss';

import messages from './messages';

class LoginJiraApp extends React.Component {
  static propTypes = {
    inModal: PropTypes.bool,
    history: PropTypes.shape({
      location: PropTypes.shape({
        pathname: PropTypes.string,
      }),
    }).isRequired,
  };
  static defaultProps = {
    inModal: false,
  };
  render() {
    const { inModal } = this.props;
    return (
      <div className={s.loginForm}>
        <h1 style={{ margin: '0 0 5px 0' }}>
          <FormattedMessage {...messages.heading} />
        </h1>
        <span className={s.subline}>
          <FormattedMessage {...messages.infoAtlassian} />
        </span>
        <form className="default-form">
          <fieldset>
            <div
              className="btn-group btn-group-justified"
              style={{ marginTop: '40px' }}
            >
              <div className="btn-group">
                <a
                  href="/jira-app/oauth/connect"
                  className={`btn btn-primary ${s.atlassianLoginButton}`}
                  onClick={() => {
                    if (inModal)
                      window.localStorage.setItem(
                        'redirect',
                        this.props.history.location.pathname,
                      );
                  }}
                >
                  <FaAtlassian className="icon--prepended" />
                  <FormattedMessage
                    {...messages.submitProvider}
                    values={{ provider: 'Jira' }}
                  />
                </a>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    );
  }
}

export default withRouter(injectIntl(withStyles(s)(LoginJiraApp)));
